export default "__VITE_ASSET__BKg8xYRG__"